import { BillEstimate } from "@flick/plan_chooser";
import { PRODUCT_LABELS } from "domain/configuration";
import {
  BillEstimateResponse,
  Product,
  ProductForDialog,
} from "domain/core/types";
import React from "react";

import ProductDialog from "./ProductDialog";
interface Props {
  currentProduct: Product;
  checked: boolean;
  handleProductChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  billEstimates?: BillEstimateResponse;
  region?: string;
  dialogProduct?: ProductForDialog[];
}

const ProductRadioButton = (props: Props) => {
  const {
    checked,
    handleProductChange,
    billEstimates,
    region,
    currentProduct,
    dialogProduct,
  } = props;
  const billEstimate =
    billEstimates?.data.filter(
      (bill) => bill.attributes.product_name === currentProduct,
    ) || [];
  const formattedBillEstimate =
    billEstimate.length > 0 ? new BillEstimate(billEstimate[0]) : undefined;
  return (
    <li className="radio_confirm" key={`product_${currentProduct}`}>
      <input
        type="radio"
        name="product"
        value={currentProduct}
        id={`product_${currentProduct}`}
        onChange={handleProductChange}
        checked={checked}
        data-msg-value-missing="We can't create your account without a plan!"
        required
      />
      <label htmlFor={`product_${currentProduct}`}>
        <span>{PRODUCT_LABELS[currentProduct]}</span>
      </label>
      {dialogProduct && formattedBillEstimate && (
        <ProductDialog
          product={dialogProduct[0]}
          currentProduct={currentProduct}
          billEstimate={formattedBillEstimate}
          region={region}
        />
      )}
    </li>
  );
};

export default ProductRadioButton;
